/**
 * Contenedor principal del módulo de Comparativos.
 * Sub-tabs: Año vs Año | Mes vs Mes | Acumulado | Clientes | Mayores Variaciones
 */
import { useState } from 'react';
import { YearVsYearTab } from './YearVsYearTab';
import { MonthVsMonthTab } from './MonthVsMonthTab';
import { AccumulatedTab } from './AccumulatedTab';
import { ClientsYearTab } from './ClientsYearTab';
import { TopVariationsTab } from './TopVariationsTab';

type SubTab = 'year' | 'month' | 'accumulated' | 'clients' | 'topVariations';

const SUB_TABS: { key: SubTab; label: string; icon: string }[] = [
  { key: 'year',         label: 'Año vs Año',          icon: '📅' },
  { key: 'month',        label: 'Mes vs Mes',           icon: '📆' },
  { key: 'accumulated',  label: 'Acumulado',            icon: '📊' },
  { key: 'clients',      label: 'Clientes',             icon: '🏢' },
  { key: 'topVariations',label: 'Mayores Variaciones',  icon: '🔝' },
];

export function ComparativosTab() {
  const [active, setActive] = useState<SubTab>('year');

  return (
    <div className="space-y-4">
      {/* Sub-tab chips */}
      <div className="flex flex-wrap gap-2 border-b border-border pb-3">
        {SUB_TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={`flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-all ${
              active === t.key
                ? 'bg-brand-600 text-white shadow-sm'
                : 'bg-surface-2 text-ink-600 hover:bg-surface-3'
            }`}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>

      {/* Contenido del sub-tab activo */}
      {active === 'year'          && <YearVsYearTab />}
      {active === 'month'         && <MonthVsMonthTab />}
      {active === 'accumulated'   && <AccumulatedTab />}
      {active === 'clients'       && <ClientsYearTab />}
      {active === 'topVariations' && <TopVariationsTab />}
    </div>
  );
}
